<template lang="pug">
.row
    .col-md-7.margin-top-10
        span(v-html="description")
        template(v-if='help')
            br
            i.ti-help-alt.text-primary  
            span  {{ help }}
    .col-md-2.col-xs-6.margin-top-10
        field(
            label="Название поля",
            :item="item"
        )
    .col-md-3.col-xs-6.margin-top-10
        button.btn.btn-default(
            @click="save(name)", 
            :class="saveButtonCls"
        ) {{ saveButtonText }}
        button.btn.btn-o.btn-danger(
            @click="save(name, true)", 
            :class="removeButtonCls"
        ) Больше не сохранять
    
</template>

<script>
export default {
    name: 'FieldWithSaveButton',
    props: {
        description: String,
        help: String,
        name: String,
        data: Object,
        initial: String
    },
    methods: {
        save(field, isClean = false) {
            // Может быть мы просто чистим это поле:
            if (isClean) {
                this.item.value = null;
            } else {
                // А может и нет
                if (!this.item.value || !this.item.value == this.data.item) {
                    this.item.valid = false;
                    return;
                }
            }

            this.disabled = true;
            this.$store.dispatch('saveInSalesIntegrationParams', {[this.name]: this.item.value})
                .then(_ => {
                    this.data[this.name] = this.item.value;
                    this.disabled = false;
                });
        }
    },
    computed: {
        /* Текущее значение поля */
        current() {
            return this.item && this.item.value;
        },
        /* Сохранённое значение поля */
        saved() {
            return this.data[this.name];
        },
        saveButtonCls() {
            return {
                disabled: this.disabled || !this.current || this.current == this.saved,
                hidden: this.current && this.current == this.saved
            };
        },
        removeButtonCls() {
            return {hidden: !this.current || this.current != this.saved};
        },
        saveButtonText() {
            return (!this.current || this.current != this.saved) ? 'Сохранять в это поле' : 'Сохранено';
        }
        // fieldNameForPvz() {
        //     const current = this.item && this.item.value,
        //         saved = this.data[this.name]

        //     return {
        //         saveCls: {disabled: this.disabled || !current || current == saved,
        //                   hidden: current && current == saved},
        //         removeCls: {hidden: !current || current != saved},
        //         buttonText: (!current || current != saved) ? 'Сохранять в это поле' : 'Сохранено'
        //     }
        // }
    },
    watch: {
        initial(value) {
            this.item.value = value;
        }
    },
    data() {
        return {
            item: {
                value: this.initial,
                valid: true
            },
            disabled: false
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/integration/FieldWithSaveButton.vue